import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { isMobile } from "../../../utils/deviceInfo";
import MessagingTriviaResultsResponses from "./Results/MessagingTriviaResultsResponses";
import MessagingTriviaResultsSummary from "./Results/MessagingTriviaResultsSummary";
import TriviaResultsRatings from "./TriviaResultsRatings";
import TriviaResultsResponses from "./TriviaResultsResponses";
import TriviaResultsSummary from "./TriviaResultsSummary";
import { withRouter } from "react-router-dom";
import { Redirect, Route, Switch } from "react-router";
import TriviaResultsInsights from "./TriviaResultsInsights";
import FilterResults from "./Results/FilterResults";
import * as url from "../../../utils/url";
import axios from "../../../axios";



function TriviaResultsComponent({ currentTrivia, type, getTrivvyForEditCall, ...props }) {
  const [tab, setTab] = useState(1);
  const [isFiltersAvailable, setIsFiltersAvailable] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const planType = props.user.profile.organizationId.trivvyPlanType;

  useEffect(() => {
    const currentBlock = props.match.params.tab;

    if (currentBlock == "results-summary") {
      setTab(1)
    }
    if (currentBlock == "results-responses") {
      setTab(2)
    }
    if (currentBlock == "results-insights" || currentBlock == "results") {
      setTab(3)
    }
  }, [])

  const changeTab = (tabValue) => {
    props.history.push(`results-${tabValue == 1 ? "summary" : tabValue == 2 ? "responses" : tabValue == 3 ? "insights" : "insights"}`);
    setTab(tabValue);
    // Reset filters when switching tabs
    const newType = tabValue === 1 ? "question" : tabValue === 2 ? "user" : tabValue === 3 ? "insights" : "";
    getTrivvyForFilters(null, newType, []);
  };



  const toCamelCase = (str) =>
    str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, "")
  // .replace(/[^a-zA-Z0-9]/g, "");


  const getTrivvyForFilters = async function (selectedValues, type, typesArray) {
    setIsFilterLoading(true);

    if (selectedValues === null) {


      if (type === "user") {
        const mergedTrivia = {
          ...currentTrivia,
          userSubmissions: ["filter"],
        };

        props.setCurrentTrivia(mergedTrivia);
        setIsFilterLoading(false);
        return;
      } else if (type === "insights") {
        const mergedTrivia = {
          ...currentTrivia,
          userSubmissions: ["filter"],
        };

        props.setCurrentTrivia(mergedTrivia);
        await getTrivvyForEditCall(type);
        setIsFilterLoading(false);
      } else {
        await getTrivvyForEditCall(type);
        setIsFilterLoading(false);

      }
      return;
    }
    const surveyId = props.match.params.id;
    const queryParams = new URLSearchParams();


    // debugger;
    for (const key in selectedValues) {
      const values = selectedValues[key];
      const camelKey = key;

      if (Array.isArray(values)) {
        for (let i = 0; i < values.length; i++) {
          queryParams.append(`filters[${camelKey}]`, values[i]);
        }
      } else if (values && typeof values === "object") {
        if (values.start !== undefined) {
          queryParams.append(`filters[${camelKey}]`, values.start);
        }
        if (values.end !== undefined) {
          queryParams.append(`filters[${camelKey}]`, values.end);
        }
      }
    }
    queryParams.append("type", type);
    queryParams.append("dateArray", typesArray.dateArray || []);
    queryParams.append("numberArray", typesArray.numberArray || []);




    try {
      const baseUrl = url.getTriviaFilteredResults(surveyId, false);
      const connector = baseUrl.indexOf("?") !== -1 ? "&" : "?";
      const response = await axios.get(baseUrl + connector + queryParams.toString());

      const data = response && response.data && response.data.data ? response.data.data : {};

      const trivvyHasResponses = response.data.trivvyHasResponses
      const userSubmissions = data.hasOwnProperty('userSubmissions') ? data.userSubmissions : undefined;

      console.log('data 121 -- ', data)
      console.log('122 type -- ', type)

      if (type === "user") {

        const mergedTrivia = {
          ...currentTrivia,
          userSubmissions: userSubmissions,
          isFiltered: true,
          trivvyHasResponses: trivvyHasResponses
        }

        console.log('224 mergedTrivia -- ', mergedTrivia)


        props.setCurrentTrivia(mergedTrivia);
        setIsFilterLoading(false);
        return;
      } else if (type === "insights") {

        const summary = data.summaryStats || {};

        console.log('142 summary -- ', summary)

        const mergedTrivia = {
          ...currentTrivia,
          insightsTotalCount: summary.otherMediumsShareCount || 0,
          insightsStartCount: summary.startCount || 0,
          // otherMediumsShareCount: summary.otherMediumsShareCount || 0,
          // startCount: summary.startCount || 0,
          // userSubmissions: userSubmissions,
          trivvyHasResponses: trivvyHasResponses,
          totalSubmissions:
            summary && summary.totalSubmissions ? summary.totalSubmissions : 0,
          averageScore: summary && summary.averageScore ? summary.averageScore : 0,
          averageTime: summary && summary.averageTime ? summary.averageTime : 0,
          averageRating: summary && summary.averageRating ? summary.averageRating : 0,
          numberOfRatings:
            summary && summary.numberOfRatings ? summary.numberOfRatings : 0,
          sentimentsScore:
            summary && summary.averageSentimentsScore
              ? summary.averageSentimentsScore
              : {
                sentiment: "NEUTRAL",
                positive: 0,
                negative: 0,
                neutral: 0,
                mixed: 0,
              },
          totalSentimentCounts:
            summary && summary.totalSentimentCounts
              ? summary.totalSentimentCounts
              : { POSITIVE: 0, NEGATIVE: 0, NEUTRAL: 0 },
        };

        props.setCurrentTrivia(mergedTrivia);
        setIsFilterLoading(false);


      } else if (type === "question") {



        console.log('182 data --- ', JSON.stringify(data))
        console.log('data.sentTo: ', data.sentToCount)

        const questionResponses = data.questionResponses || [];
        const optionResponseMatches = data.option_response_matching_records || [];

        const optionResponseMap = {};
        for (let i = 0; i < optionResponseMatches.length; i++) {
          const item = optionResponseMatches[i];
          if (item && item.option_id) {
            optionResponseMap[item.option_id] = item.totalResponded;
          }
        }

        const updatedQuestions = currentTrivia.questions.map(function (q) {
          const match = questionResponses.find(function (r) {
            return r.question_id === q.question_id;
          });

          const updatedOptions = q.options.map(function (opt) {
            return {
              ...opt,
              totalResponded: optionResponseMap[opt.option_id] || 0,
            };
          });
          return {
            ...q,
            questionTotalCount: data.sentToCount || 0,
            // questionStartCount: summary.startCount || 0,
            users_responded: match && match.users_responded ? match.users_responded : 0,
            sentimentCounts: match && match.sentimentCounts ? match.sentimentCounts : { POSITIVE: 0, NEGATIVE: 0, NEUTRAL: 0 },
            averageSentimentsScore: match && match.averageSentimentsScore ? match.averageSentimentsScore : {},
            linearNumericResponsesCounts:
              q.question_type === "LINEAR_NUMERIC" && match && match.linearNumericResponsesCounts
                ? match.linearNumericResponsesCounts
                : {},
            textResponsesCounts: match && match.textResponsesCounts ? match.textResponsesCounts : 0,
            options: updatedOptions,
          };
        });

        const mergedTrivia = {
          ...currentTrivia,
          questionTotalCount: data.sentToCount || 0,
          questions: updatedQuestions,
          trivvyHasResponses: trivvyHasResponses,
        };

        console.log('224 mergedTrivia -- ', mergedTrivia)

        props.setCurrentTrivia(mergedTrivia);
        setIsFilterLoading(false);
        return;

      }

    } catch (err) {
      console.error("Error fetching filtered results", err);
      setIsFilterLoading(false);
    }
  };








  const handleApplyFilter = async (selectedValues, typesArray) => {



    const type = tab === 1 ? "question" : tab === 2 ? "user" : tab === 3 ? "insights" : "";
    await getTrivvyForFilters(selectedValues, type, typesArray);


  }

  const handleClearFilter = async () => {
    const type = tab === 1 ? "question" : tab === 2 ? "user" : tab === 3 ? "insights" : "";
    await getTrivvyForFilters(null, type, []);

  }


  let showFilters = currentTrivia.isMessaging
    ? isFiltersAvailable
    : isFiltersAvailable && (currentTrivia.startCount || currentTrivia.trivvyHasResponses);

  if (currentTrivia) {
    // let showFilter = true


    if (currentTrivia.totalSubmissions > 0) {
      let { allowAnonymousResponses, totalSubmissions } = currentTrivia
      if (allowAnonymousResponses) {
        if (totalSubmissions <= 5) {
          showFilters = true
        }
      }
    }


    return (
      <div id={"trivvy_result_wrapper"}>
        <div>
          <Row className="bg-white top-trivia-results-row">
            <Col sm={2}></Col>
            <Col sm={8}>
              <div className="bg-white">
                <ul
                  className="data-user trivia-edit-top-nav-survey-ui"
                  style={{
                    width: isMobile ? "inherit" : "400px",
                    marginBottom: "-2px",
                    margin: "0 auto",
                  }}
                >
                  <li className="survey_top_div_padding_manage">
                    <a
                      className={`res_menu_option ${tab == 3 ? "profile_page_menu_option_active" : ""
                        }`}
                      onClick={() => changeTab(3)}
                      style={{
                        width: isMobile ? "inherit" : "200px",
                      }}
                    >
                      Insights
                    </a>
                  </li>

                  {!currentTrivia.isMessaging && (
                    <li>
                      <a
                        className={`res_menu_option ${tab == 1 ? "profile_page_menu_option_active" : ""
                          }`}
                        onClick={() => changeTab(1)}
                        style={{
                          width: isMobile ? "inherit" : "200px",
                        }}
                      >
                        By Question
                      </a>
                    </li>
                  )}

                  <li>
                    <a
                      className={`res_menu_option ${tab == 2 ? "profile_page_menu_option_active" : ""
                        }`}
                      onClick={() => changeTab(2)}
                      style={{
                        width: isMobile ? "inherit" : "200px",
                      }}
                    >
                      By User
                    </a>
                  </li>

                  {/* <li>
                    <a
                      className={`${
                        tab == 3 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => changeTab(3)}
                    >
                      Rating
                    </a>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col sm={2}></Col>
          </Row>
        </div>

        <Row className="TriviaResultsResponsesContainer "
          style={{
            padding: showFilters ? "0px" : "0px 2em"
          }}
        >
          {/* <Switch>
            trivia_results_section_ui_height_wrapper

            <Route exact path={props.match.url + "/responses"}>
            ff
            </Route>

           

            <Redirect from="*" to={props.match.url + "/summary"} />
          </Switch> */}

          {currentTrivia.isMessaging ? (
            <>
              <Col
                sm={showFilters ? 3 : 0}
                className="trivia_results_ratings_wrapper"
                style={{
                  display: showFilters ? "block" : "none",
                }}
              >
                <div
                  style={{
                    position: showFilters ? "static" : "absolute",
                    opacity: showFilters ? 1 : 0,
                    zIndex: showFilters ? 1 : -1,
                  }}
                >
                  <FilterResults
                    setFilterResultsValues={handleApplyFilter}
                    setClearFilters={handleClearFilter}
                    publishedDate={
                      currentTrivia.isMessaging
                        ? currentTrivia.createdOn
                        : currentTrivia.publishedDate
                    }
                    type={
                      tab === 1
                        ? "question"
                        : tab === 2
                          ? "user"
                          : tab === 3
                            ? "insights"
                            : ""
                    }
                    currentTrivia={currentTrivia}
                    setIsFiltersAvailable={setIsFiltersAvailable}
                  />
                </div>
              </Col>

              <Col sm={showFilters ? 9 : 12}>
                <div className={showFilters ? "col-sm-11" : "col-sm-12"}>
                  {tab == 1 ? (
                    <MessagingTriviaResultsSummary trivia={currentTrivia} />
                  ) : tab === 3 ? (
                    <TriviaResultsInsights
                      questions={currentTrivia.questions}
                      surveyId={currentTrivia._id}
                      allowAttempts={currentTrivia.allowAttempts}
                      currentTrivvy={currentTrivia}
                      setCurrentTrivia={props.setCurrentTrivia}
                      user={props.user.profile}
                      startCount={currentTrivia.insightsStartCount && currentTrivia.insightsStartCount > 0 ? currentTrivia.insightsStartCount : currentTrivia.startCount}
                      isFilterLoading={isFilterLoading}
                    />
                  ) : null}

                  <div
                    style={{
                      opacity: tab === 2 ? 1 : 0,
                      zIndex: tab === 2 ? 1 : -1,
                      pointerEvents: tab === 2 ? "all" : "none",
                    }}
                  >
                    <MessagingTriviaResultsResponses
                      trivia={currentTrivia}
                      user={props.user}
                      userSubmissions={currentTrivia.userSubmissions}
                      isFilterLoading={isFilterLoading}
                    />
                  </div>
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col
                sm={showFilters ? 3 : 0}
                className="trivia_results_ratings_wrapper"
                style={{
                  display: showFilters ? "block" : "none",
                }}
              >
                <div
                  style={{
                    position: showFilters ? "static" : "absolute",
                    opacity: showFilters ? 1 : 0,
                    zIndex: showFilters ? 1 : -1,
                  }}
                >
                  <FilterResults
                    setFilterResultsValues={handleApplyFilter}
                    setClearFilters={handleClearFilter}
                    publishedDate={currentTrivia.publishedDate}
                    type={
                      tab === 1
                        ? "question"
                        : tab === 2
                          ? "user"
                          : tab === 3
                            ? "insights"
                            : ""
                    }
                    currentTrivia={currentTrivia}
                    setIsFiltersAvailable={setIsFiltersAvailable}
                  />
                </div>
              </Col>

              <Col
                sm={showFilters ? 9 : 12}
                style={{ padding: showFilters ? "0px 10px" : "0px 35px" }}
              >
                <div className={showFilters ? "col-sm-11" : "col-sm-12"}>
                  {tab == 1 ? (
                    <TriviaResultsSummary
                      questions={currentTrivia.questions}
                      surveyId={currentTrivia._id}
                      allowAttempts={currentTrivia.allowAttempts}
                      currentTrivvy={currentTrivia}
                      setCurrentTrivia={props.setCurrentTrivia}
                      user={props.user.profile}
                    />
                  ) : tab === 2 ? null : tab === 3 ? (
                    <TriviaResultsInsights
                      surveyId={currentTrivia._id}
                      allowAttempts={currentTrivia.allowAttempts}
                      currentTrivvy={currentTrivia}
                      setCurrentTrivia={props.setCurrentTrivia}
                      user={props.user.profile}
                      startCount={currentTrivia.insightsStartCount && currentTrivia.insightsStartCount > 0 ? currentTrivia.insightsStartCount : currentTrivia.startCount}
                      isFilterLoading={isFilterLoading}
                    />
                  ) : (
                    ""
                  )}

                  <div
                    style={{
                      opacity: tab == 2 ? 1 : 0,
                      zIndex: tab == 2 ? 1 : -1,
                      pointerEvents: tab == 2 ? "all" : "none",
                    }}
                  >
                    <TriviaResultsResponses
                      questions={currentTrivia.questions}
                      surveyData={currentTrivia}
                      allowAttempts={currentTrivia.allowAttempts}
                      numberOfAttempts={currentTrivia.numberOfAttempts}
                      userSubmissions={currentTrivia.userSubmissions}
                      isFiltered={currentTrivia.isFiltered}
                      isFilterLoading={isFilterLoading}
                      totalSumOfNumResponses={
                        (currentTrivia.userSubmissions && currentTrivia.userSubmissions.total != null)
                          ? currentTrivia.userSubmissions.total
                          : currentTrivia.totalSubmissions
                      }
                    />
                  </div>
                </div>
              </Col>
            </>
          )}
        </Row>
      </div>
    );
  } else {
    return <div></div>;
  }
}

export default withRouter(TriviaResultsComponent)
